import { useMemo } from 'react';
import { UNFILED_ASSETS_ID } from 'framework-listing-lib/internal/Folders/constants/folders';
import useCrmObjectTypeFetchParams from 'framework-listing-lib/internal/hooks/useCrmObjectTypeFetchParams';
import { combineFilters } from 'framework-listing-lib/utils/filters';
import { useHiddenFilter } from 'framework-listing-lib/hooks/useListingLibFilters';
import { useHiddenFolderFilter } from './useFolderProps';
import { updateHiddenFilterForFolder } from '../utils/filters';
export default function useUnfiledAssetVariables() {
  const variables = useCrmObjectTypeFetchParams();
  const hiddenFolderFilter = useHiddenFolderFilter();
  const hiddenFilter = useHiddenFilter();
  const filterGroups = useMemo(() => {
    const filtersForFolderAndHidden = updateHiddenFilterForFolder({
      hiddenFilter,
      isFoldersMode: true,
      folderId: UNFILED_ASSETS_ID
    });
    return combineFilters(filtersForFolderAndHidden.filterGroups, hiddenFolderFilter ? hiddenFolderFilter.filterGroups : []);
  }, [hiddenFilter, hiddenFolderFilter]);
  return useMemo(() => Object.assign({}, variables, {
    fetchParams: Object.assign({}, variables.fetchParams, {
      filterGroups
    })
  }), [filterGroups, variables]);
}